/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateIntegrationPrivacyRequestRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {CreatePrivacyRequestResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const createIntegrationPrivacyRequest = (request: CreateIntegrationPrivacyRequestRequest, options?: CashRequestOptions) => post<CreateIntegrationPrivacyRequestRequest, CreatePrivacyRequestResponse>("/2.0/cash/create-integration-privacy-request", request, {...options, rejectOnError: true })